module.exports = __webpack_public_path__ + "static/media/RemoteMission.b3f0e83a.svg";